import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import StickerController from "./sticker_controller"
application.register("sticker", StickerController)

import SwalController from "./swal_controller"
application.register("swal", SwalController)

import ScrollTabsController from "./scroll_tabs_controller"
application.register("scroll-tabs", ScrollTabsController)

import TeamFilterController from "./team_filter_controller"
application.register("team-filter", TeamFilterController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import AdminDropdownController from "./admin_dropdown_controller"
application.register("admin-dropdown", AdminDropdownController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import QuickAddController from "./quick_add_controller"
application.register("quick-add", QuickAddController)

import ActionDropdownController from "./action_dropdown_controller"
application.register("action-dropdown", ActionDropdownController)

import StickerFrameController from "./sticker_frame_controller"
application.register("sticker-frame", StickerFrameController)

import UserDropdownController from "./user_dropdown_controller"
application.register("user-dropdown", UserDropdownController)

